import { ReactNode } from "react";
import { getDebugMode } from "src/utils";
import { Css } from "~generated/css";

// Wrap debug message in a standard purple
export function DebugText({ children }: { children: ReactNode }) {
  if (!getDebugMode()) return null;

  return <div css={Css.purple600.$}>{children}</div>;
}
